import {NotificationService} from "../../services/NotificationService";
import {EditPluginModel} from "../../models/edit/EditPluginModel";
import {EditBaseCtrl} from "./EditBaseCtrl";
import {Plugin} from '../../entities/Plugin'
import { StateService, StateParams } from "@uirouter/angularjs";

export class EditPluginCtrl extends EditBaseCtrl<Plugin> {
  public static $inject = ['$scope','$state','$stateParams','EditPluginModel','NotificationService'];
  b64Object:any;
  constructor($scope:any,
              stateService:StateService,
              stateParamsService:StateParams,
              public model:EditPluginModel,
              public notifyService:NotificationService) {
    super($scope,stateService,stateParamsService,notifyService, model);
    $scope.vm = this;
    this.loadData().then((ok:any)=>{
      this.$scope.$watch(() => this.b64Object,(newValue: any, oldValue: any) => {
        if(newValue != oldValue) {
          var b64Val = newValue.base64;
          //try upload of base64 data to filedata
          this.model.b64String = b64Val;
        }
      });
    });
  }
  save():void{
    this.model.saveData().then((ok)=>{
      if(ok)
        this.stateService.go("admin.plugins");
    }).catch((exc)=>{
      this.notifyService.notifyError(exc);
    });
  }
  cancel():void{
    this.stateService.go("admin.plugins");
  }
}
